import PropTypes from 'prop-types';
var flexSpotItem = PropTypes.shape({
  classes: PropTypes.arrayOf(PropTypes.string),
  html: PropTypes.shape({
    html: PropTypes.string
  }),
  image: PropTypes.instanceOf(PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number
  })) || null,
  video: PropTypes.instanceOf(PropTypes.shape({})) || null,
  link: PropTypes.instanceOf(PropTypes.shape({})) || null
});
var flexSpotSettings = PropTypes.shape({
  preElementItems: PropTypes.arrayOf(flexSpotItem),
  postElementItems: PropTypes.arrayOf(flexSpotItem),
  elements: PropTypes.arrayOf(PropTypes.shape({
    items: PropTypes.arrayOf(flexSpotItem)
  }))
});
export { flexSpotSettings, flexSpotItem };